import React from 'react';
import { BadgeCheckIcon, StarIcon } from 'lucide-react';
interface TestimonialCardWithImageProps {
  name: string;
  dogName: string;
  dogBreed: string;
  testimonial: string;
  image: string;
  date: string;
  rating: number;
  metrics: {
    label: string;
    value: string;
  }[];
}
export function TestimonialCardWithImage({
  name,
  dogName,
  dogBreed,
  testimonial,
  image,
  date,
  rating,
  metrics
}: TestimonialCardWithImageProps) {
  return <div className="bg-white rounded-xl shadow-md overflow-hidden transition-all duration-300 transform hover:scale-[1.02] hover:shadow-lg" data-id="element-289">
      {/* Image */}
      <div className="relative" data-id="element-290">
        <img src={image} alt={`${dogName} the ${dogBreed} with The Daily Foundation Chew supplement`} className="w-full h-60 object-cover" data-id="element-291" />
      </div>
      {/* Content */}
      <div className="p-6" data-id="element-292">
        {/* Header with verification */}
        <div className="flex justify-between items-start mb-4" data-id="element-293">
          <div data-id="element-294">
            <h3 className="font-bold text-lg flex items-center" data-id="element-295">
              {name} & {dogName}
              <span className="ml-2 bg-purple-100 text-purple-800 text-xs px-2 py-1 rounded-full flex items-center" data-id="element-296">
                <BadgeCheckIcon className="w-3 h-3 mr-1" data-id="element-297" />
                Verified
              </span>
            </h3>
            
          </div>
          <div className="flex" data-id="element-298">
            {[...Array(5)].map((_, i) => <StarIcon key={i} className={`w-4 h-4 ${i < rating ? 'text-yellow-400 fill-yellow-400' : 'text-gray-300'}`} data-id="element-299" />)}
          </div>
        </div>
        {/* Testimonial */}
        <p className="text-gray-700 mb-5" data-id="element-300">"{testimonial}"</p>
        {/* Metrics */}
        <div className="grid grid-cols-2 gap-3 mb-4" data-id="element-301">
          {metrics.map((metric, index) => <div key={index} className="bg-purple-50 p-3 rounded-lg text-center" data-id="element-302">
              <p className="font-bold text-purple-800 text-xl" data-id="element-303">
                {metric.value}
              </p>
              <p className="text-sm text-gray-600" data-id="element-304">{metric.label}</p>
            </div>)}
        </div>
        {/* Footer */}
        <div className="mt-4 pt-4 border-t border-gray-100 flex justify-between items-center text-sm text-gray-500" data-id="element-305">
          <p data-id="element-306">{date}</p>
        </div>
      </div>
    </div>;
}